import { RouterPath } from "@/models/enum/routerPath";
import AdministratorView from "@/views/admin-view/AdministratorView.vue";
import CreateUserView from "@/views/admin-view/CreateUserView.vue";
import ViewUserView from "@/views/admin-view/ViewUserView.vue";
import ViewTrustGroupView from "@/views/admin-view/ViewTrustGroupView.vue";
import ListLockedUsersView from "@/views/admin-view/ListLockedUsersView.vue";
import ListUsersView from "@/views/admin-view/ListAdminUsersView.vue";
import CreateCustomerView from "@/views/admin-view/CreateCustomerView.vue";
import RecalculateStatsView from "@/views/admin-view/RecalculateStatsView.vue";
import CustomersOverview from "@/views/admin-view/CustomersOverview.vue";
const adminRoutes = [
  {
    path: RouterPath.AdministratorPage,
    name: "administratorPage",
    component: AdministratorView,
    meta: { requiresAdmin: true },
  },
  {
    path: RouterPath.AdminCreateUserPage,
    name: "createUserPage",
    component: CreateUserView,
    meta: { requiresAdmin: true },
  },
  {
    path: RouterPath.AdminViewUserPage,
    name: "viewUserPage",
    component: ViewUserView,
    meta: { requiresAdmin: true },
  },
  {
    path: RouterPath.AdminViewTrustGroupPage,
    name: "viewTrustGroupPage",
    component: ViewTrustGroupView,
    meta: { requiresAdmin: true },
  },
  {
    path: RouterPath.AdminListLockedUsersPage,
    name: "listLockedUsersPage",
    component: ListLockedUsersView,
    meta: { requiresAdmin: true },
  },
  {
    path: RouterPath.AdminListUsersPage,
    name: "listUsersPage",
    component: ListUsersView,
    meta: { requiresAdmin: true },
  },
  {
    path: RouterPath.AdminCreateCustomer,
    name: RouterPath.AdminCreateCustomer,
    component: CreateCustomerView,
    meta: { requiresAdmin: true },
  },
  {
    path: RouterPath.AdminRecalculateStatsPage,
    name: "recalculateStatsPage",
    component: RecalculateStatsView,
    meta: { requiresAdmin: true },
  },
  {
    path: RouterPath.AdminCustomersOverview,
    name: "adminCustomersOverview",
    component: CustomersOverview,
    meta: { requiresAdmin: true },
  },
];

export default adminRoutes;
